import watch from "../assets/images/friend.svg";

const Sponcers = () => {
  return (
    <div className="bg-gray-900 sm:h-[50vh]">
      <div className="sm:w-[90%] sm:ml-auto sm:mr-auto sm:flex sm:justify-around items-center border-t-4 border-gray-700">
        <div className=" px-3 py-2">
          <h1 className="text-gray-300 font-extrabold md:text-left text-center py-2 text-xl md:text-3xl lg:text-6xl">
            Join Our Coummunity
          </h1>

          <p className=" text-gray-300 text-base text-center sm:text-left sm:text-2xl max-w-lg">
            More than 10 million people using Andromeda now it's you'r turn
          </p>
          <div className="flex justify-center sm:justify-start">
            <button className=" px-6 py-1 border-2 border-green-300 text-white hover:bg-green-400 hover:text-black focus:outline-none  mt-3">
              Join Us
            </button>
          </div>
        </div>
        <div className="px-3 py-2 p-3 mt-4 flex justify-center">
          <img src={watch} alt="" className="h-[300px]" />
        </div>
      </div>
    </div>
  );
};

export default Sponcers;
